export enum CapacitorPlatformEnum {
	WEB = 'web',
	OIS = 'ios',
	ANDROID = 'android',
}
